import React from 'react';
import { Typography } from 'antd';
import { FUNCTION_SPECS } from '../../shared/formula/functionRegistry';

const FUNCTIONS_WITH_HELP = FUNCTION_SPECS.filter((spec) => spec.help);

/**
 * Lists the formula functions from the shared function registry with a short
 * description. Clicking a function inserts its template into the formula.
 */
const FormulaFunctions = ({ onInsert }) => {
    if (FUNCTIONS_WITH_HELP.length === 0) return null;

    return (
        <div className="formula-functions">
            <Typography.Text type="secondary" style={{ display: 'block', marginBottom: '4px' }}>
                Insert function (click to add at the cursor):
            </Typography.Text>

            {FUNCTIONS_WITH_HELP.map((spec) => (
                <div
                    key={spec.name}
                    className="formula-functions-item"
                    role="button"
                    tabIndex={0}
                    // Keep focus (and the caret) in the formula field.
                    onMouseDown={(e) => e.preventDefault()}
                    onClick={() => onInsert(spec.help.template)}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            onInsert(spec.help.template);
                        }
                    }}
                >
                    <code className="formula-functions-signature">{spec.help.signature}</code>
                    <div className="formula-functions-description">{spec.help.description}</div>
                    {spec.help.example && (
                        <div className="formula-functions-example">
                            Example: <code>{spec.help.example}</code>
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
};

export default FormulaFunctions;
